import { useState, FormEvent } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useConfirmPasswordReset, AuthError , PasswordResetForm  } from '@auth';
import { routes } from '@/shared/routes';

export default function PasswordResetPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const intl = useIntl();
  const confirmPasswordReset = useConfirmPasswordReset();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);

    if (password !== confirmPassword) {
      setError(intl.formatMessage({ id: 'auth.signUp.confirmPasswordRequired' }));
      return;
    }

    if (!token) {
      setError(intl.formatMessage({ id: 'auth.passwordReset.invalidToken' }));
      return;
    }

    try {
      await confirmPasswordReset.mutateAsync({ token, password });
      navigate(routes.app.signin, { state: { passwordResetSuccess: true } });
    } catch (error_) {
      const authError = error_ as AuthError;
      setError(authError.error ?? intl.formatMessage({ id: 'auth.passwordReset.invalidToken' }));
    }
  };

  const handleBackToSignIn = () => {
    navigate(routes.app.signin);
  };

  return (
    <PasswordResetForm
      password={password}
      confirmPassword={confirmPassword}
      error={error}
      isLoading={confirmPasswordReset.isPending}
      onPasswordChange={setPassword}
      onConfirmPasswordChange={setConfirmPassword}
      onSubmit={handleSubmit}
      onBackToSignIn={handleBackToSignIn}
    />
  );
}
